import styled from '@emotion/styled'
import { Button } from 'antd'

export const MarginButton = styled(Button)`
  margin: 0px 0px 10px 15px;
`
